import type { FileWithPath } from 'react-dropzone'
import type { IUserFile, IDirectory } from '~/types/user-file'

import config from '~/config'
import { request } from '~/utils/request'

/** @doc https://toolbox-dev-europe-west9-1058312231336.europe-west9.run.app/#get-/user-files/directory/-directoryID- */
export const getUserFilesByDirectory = ({
  directoryId,
}: {
  directoryId: string
}): Promise<{ content?: IUserFile[]; current_directory: IDirectory }> => {
  return request({
    url: `${config.TOOLBOX_API}/user-files/directory/${directoryId}`,
  })
}

/** @doc https://toolbox-dev-europe-west9-1058312231336.europe-west9.run.app/#post-/user-files */
export const createUserFile = (payload: { directory_id: string; file_id: string }): Promise<IUserFile> => {
  return request({
    data: payload,
    method: 'POST',
    url: `${config.TOOLBOX_API}/user-files`,
  })
}

export const uploadUserFile = ({ download_url, file }: { download_url: string; file: FileWithPath }): Promise<void> => {
  return request({
    data: file,
    method: 'PUT',
    url: download_url,
  })
}

export const deleteUserFile = (fileId: string): Promise<void> => {
  return request({
    method: 'DELETE',
    url: `${config.TOOLBOX_API}/user-files/${fileId}`,
  })
}

/** @doc https://toolbox-dev-europe-west9-1058312231336.europe-west9.run.app/#put-/user-files/-fileID- */
export const updateFileLocation = ({ directoryId, fileId }: { directoryId: string; fileId: string }): Promise<void> => {
  return request({
    data: { directory_id: directoryId },
    method: 'PUT',
    url: `${config.TOOLBOX_API}/user-files/${fileId}`,
  })
}

/** @doc https://toolbox-dev-europe-west9-1058312231336.europe-west9.run.app/#post-/user-files/directory */
export const createDirectory = ({ name, path }: { name: string; path: string }): Promise<IDirectory> => {
  return request({
    data: { name, path },
    method: 'POST',
    url: `${config.TOOLBOX_API}/user-files/directory`,
  })
}

/** @doc https://toolbox-dev-europe-west9-1058312231336.europe-west9.run.app/#delete-/user-files/directory/-directoryID- */
export const deleteDirectory = (directoryId: string): Promise<void> => {
  return request({
    method: 'DELETE',
    url: `${config.TOOLBOX_API}/user-files/directory/${directoryId}`,
  })
}

/** @doc https://toolbox-dev-europe-west9-1058312231336.europe-west9.run.app/#put-/user-files/directory/-directoryID- */
export const updateDirectoryLocation = ({
  directoryId,
  name,
  path,
}: {
  directoryId: string
  name?: string
  path: string
}): Promise<void> => {
  return request({
    data: { name, path },
    method: 'PUT',
    url: `${config.TOOLBOX_API}/user-files/directory/${directoryId}`,
  })
}
